import { lazy } from "react";

export const Routes = [
    {
        path: "/login",
        component: lazy(() => import("./pages/Login")),
        authCheckType: "unauthed"
    },
    {
        path: "/",
        component: lazy(() => import("./pages/VehicleDataAnalysis")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/reports",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/information",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/ev-data",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/battery-history",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dtc",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dmu/bms",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dmu/engine",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },    
    {
        path: "/analyze/dmu/mcu",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dmu/scr",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dmu/transmission",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dmu/vcu",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dpd/chart",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dpd/history",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    },
    {
        path: "/analyze/dpd/relating-items",
        component: lazy(() => import("./pages/Reports")),
        authCheckType: "authed"
    }
];
